import React from 'react';
import { Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { STATUS_COLORS, STATUS_LABELS } from './constants';

const useStyles = makeStyles(() => ({
  chip: {
    fontWeight: 600,
    color: '#fff',
  },
}));

export const StatusChip = ({ status }) => {
  const classes = useStyles();
  return (
    <Chip
      size="small"
      label={STATUS_LABELS[status] || status}
      className={classes.chip}
      style={{ backgroundColor: STATUS_COLORS[status] || '#757575' }}
    />
  );
};

export default StatusChip;
